module.exports = __webpack_public_path__ + "img/134.a7ead715.jpg";